import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import { useState, useEffect } from "react";
import  axios  from "axios";
import StartCard from "../../components/StartCard";
import SalesChart from "../../components/SaleChart";
import RealEstateAgentOutlinedIcon from '@mui/icons-material/RealEstateAgentOutlined';
import { tokens } from "../../theme";
import TopSellingProducts from "../../components/TopSellingProducts";
import ActivityLogs from "../../components/ActivityLogs";
const Dashboard = () => {
  const [productCount, setProductCount] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [weeklySales, setWeeklySales] = useState(0);
  const [netProfit, setNetProfit] = useState(0);
    
  useEffect(() => {
    fetchTotalSales();
    fetchWeeklySales();
    fetchTotalProducts();
    fetchNetProfit();
  }, []);

  const fetchTotalSales = async () => {
    try {
      const response = await axios.get("https://store.petplanet.rw/api/sales/total");
      setTotalSales(response.data.total_sales);
    } catch (error) {
      console.error("Error fetching total sales:", error);
    }
  };
  const fetchTotalProducts = async () => {
    try {
      const response = await axios.get("https://store.petplanet.rw/api/products/total");
      setProductCount(response.data.total_products);
    } catch (error) {
      console.error("Error fetching total sales:", error);
    }
  };
  const fetchNetProfit = async () => {
    try {
      const response = await axios.get("https://store.petplanet.rw/api/sales/net-profit");
      setNetProfit(response.data.net_profit);
    } catch (error) {
      console.error("Error fetching net profit:", error);
    }
  };

  const fetchWeeklySales = async () => {
    try {
      const response = await axios.get("https://store.petplanet.rw/api/sales/weekly");
      setWeeklySales(response.data.weekly_sales);
    } catch (error) {
      console.error("Error fetching weekly sales:", error);
    }
  };
  

  return (
    <Box m="20px" mt="80px"> 
        <Typography variant="h2" fontWeight="600">
           Dashboard
        </Typography>
       <motion.div
        style={{
          marginTop: "20px",
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
        }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
      <StartCard
        name="Total Sales"
        icon={TrendingUpOutlinedIcon}
        value={
          <>
            <Box display="flex" alignItems="center">
            <span style={{ fontSize: "18px", marginRight: "4px" }}>
              RWF
            </span>
            {totalSales.toLocaleString()}
            </Box>
           
          </>
        }
        color= {tokens.blueAccent[400]}
      />

      <StartCard
        name="Weekly Sales"
        icon={RealEstateAgentOutlinedIcon}
        value={
          <>
            <Box display="flex" alignItems="center">
            <span style={{ fontSize: "18px", marginRight: "4px" }}>
              RWF
            </span>
            {weeklySales.toLocaleString()}
            </Box>
           
          </>
        }
        color= {tokens.blueAccent[400]}
        background= "linear-gradient(180deg, rgba(236,72,153,0.08), rgba(236,72,153,0.02))"

      />
      <StartCard
        name="Total Products"
        icon={TimelineOutlinedIcon}
        value={productCount}
        color="#333"
        background= "linear-gradient(180deg, rgba(71, 184, 78, 0.12),  rgba(71, 184, 78, 0.04))"
      />
      <StartCard
        name="Net Profit"
        icon={BarChartOutlinedIcon}
        value={
          <>
            <Box display="flex" alignItems="center">
            <span style={{ fontSize: "18px", marginRight: "4px" }}>
              RWF
            </span>
            {netProfit.toLocaleString()}
            </Box>
           
          </>
        }
        color= {tokens.blueAccent[400]}
        background="linear-gradient(180deg, rgba(255,170,0,0.08), rgba(255,170,0,0.02))"
      />
      
      </motion.div>
      <Box mt="30px">
        <Box
          display="grid"
          gridTemplateColumns="3fr 1fr"
          gap="20px"
        >
          
          {/* LEFT SIDE */}
          <Box display="flex" flexDirection="column" gap="20px">
      
            {/* SALES / INVENTORY CHART */}
            <SalesChart />
      
            {/* TOP SELLING PRODUCTS */}
            <TopSellingProducts />
      
          </Box>
      
          {/* RIGHT SIDE */}
          <ActivityLogs />
      
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
